/**
 * Given an array of data series. Find a matching compare series for the metric
 * @param dataSeries
 * @param metricQualified
 * @param name
 */
export function getCompareSeries(dataSeries, metricQualified, name) {
    const originalSeries = dataSeries.find((series) => {
        if (series.metricQualified === metricQualified && series.name === name && !series.isCompareSeries) {
            return true;
        }
        else {
            return false;
        }
    });
    const compareSeries = dataSeries.find((series) => {
        if (series.metricQualified === metricQualified && series.name === name && series.isCompareSeries) {
            return true;
        }
        else {
            return false;
        }
    });
    return [originalSeries, compareSeries];
}
